import { Injectable } from '@angular/core';
import { Client } from '@shared/entities/client';
import { Paginate } from '@shared/entities/paginate';
import { BehaviorSubject, Observable, Subject, switchMap, take, tap } from 'rxjs';
import { ApiService, Pagination } from './api.service';

const LOG_PREFIX = '[Api][Client] ';
const CLIENTS_PER_PAGE = 10;

export interface ClientFilterURL {
  name?: string;
  location?: string;
  type?: string;
  serialNumber?: string;
  // orderBy?: string;
  // direction?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root'
})
export class ClientService extends ApiService<Client> {
  private refresh$: Subject<Pagination>;
  all$: Observable<Paginate<Client>>;
  currentFilters: ClientFilterURL = {};
  currentPaginator: Pagination;

  set filters(value: ClientFilterURL) {
    this.currentFilters = value;
    this.refresh(1, CLIENTS_PER_PAGE);
  }

  constructor() {
    const masterUrl = '/clients';
    const detailUrl = '/clients';

    super(Client, masterUrl, detailUrl, 'items');

    this.currentPaginator = { page: 1, perPage: CLIENTS_PER_PAGE };

    this.refresh$ = new BehaviorSubject<Pagination>(this.currentPaginator);
    this.all$ = this.refresh$.pipe(
      switchMap((pagination) => {
        if (this.currentFilters.name) {
          this.setUrlParameter('name', this.currentFilters.name);
        }
        if (this.currentFilters.location) {
          this.setUrlParameter('location', this.currentFilters.location);
        }
        if (this.currentFilters.serialNumber) {
          this.setUrlParameter('serialNumber', this.currentFilters.serialNumber);
        }
        if (this.currentFilters.type) {
          this.setUrlParameter('type', this.currentFilters.type);
        }
        // if (this.currentFilters.orderBy) {
        //   this.setUrlParameter('order_by', this.currentFilters.orderBy);
        //   this.setUrlParameter('direction', 'ASC');
        // }
        return this.paginate(Client, pagination.page, pagination.perPage);
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      })
    );
  }

  getAllCompanies(): Observable<Client[]> {
    return this.findAll();
  }

  refresh(page: number, perPage: number = CLIENTS_PER_PAGE) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this.currentPaginator = { page, perPage };
    this.refresh$.next(this.currentPaginator);

    return this.all$.pipe(take(1));
  }
}
